module.exports = __webpack_public_path__ + "static/media/personality_quiz_icon--active.00447a02.svg";